// InvoiceHeader.js - Component for invoice logo, number, date, and due date.
// LogoUploader added; dates moved under number.
// Updated: Balance Due is now a read-only display (derived from total), with theme-adaptive highlight (bg-light for light theme, bg-secondary for dark theme), larger font, bold label and value, left-aligned to match date labels.
// Fixed: Removed editable input to prevent user changes; value always reflects the total amount.
// Note: balanceDue prop is now passed as total from parent for auto-syncing.
import React from 'react';
import Form from 'react-bootstrap/Form';
import LogoUploader from './LogoUploader';
import { useGlobalContext } from '../hooks/useGlobalContext';
import { useTranslation } from 'react-i18next';

const InvoiceHeader = ({ invoiceDate, dateOfIssue, invoiceNumber, editField, logo, setLogo, balanceDue, currency }) => {
  const { theme } = useGlobalContext(); // Access theme from global context.
  const { t } = useTranslation(); // Hook for translations.

  return (
    <div className="d-flex flex-row align-items-start justify-content-between mb-3">
      <div className="d-flex flex-column">
        <LogoUploader logo={logo} setLogo={setLogo} theme={theme} /> {/* Pass theme for dark mode. */}
      </div>
      <div className="d-flex flex-column align-items-end">
        <div className="d-flex flex-row align-items-center mb-2">
          <h3 className="fw-bold me-2">{t('invoiceNumber')}&nbsp;</h3>
          <Form.Control type="number" value={invoiceNumber} name="invoiceNumber" onChange={editField} min="1" style={{ maxWidth: '70px' }} required />
        </div>
        <div className="d-flex flex-row align-items-center mb-2">
          <span className="fw-bold d-block me-2">{t('date')}</span>
          <Form.Control type="date" value={invoiceDate} name="invoiceDate" onChange={editField} style={{ maxWidth: '150px' }} required />
        </div>
        <div className="d-flex flex-row align-items-center mb-2">
          <span className="fw-bold d-block me-2" style={{ whiteSpace: 'nowrap' }}>{t('dueDate')}</span>
          <Form.Control type="date" value={dateOfIssue} name="dateOfIssue" onChange={editField} style={{ maxWidth: '150px' }} required />
        </div>
        {/* Updated: Read-only Balance Due display with theme-adaptive highlight (conditional bg-light/bg-secondary for light/dark modes), larger font, bold text, and left-aligned to match date labels.
            Value is derived from total (passed as balanceDue prop) and updates automatically. Uses theme from context for explicit adaptation. */}
        <div className={`d-flex flex-row align-items-center p-2 mt-2 ${theme === 'light' ? 'bg-light' : 'bg-secondary'}`} style={{ borderRadius: '4px', fontSize: '1.25em' }}>
          <span className="fw-bold me-2">{t('balanceDue')}:</span>
          <span className="fw-bold" style={{ maxWidth: '100px', display: 'inline-block' }}>{currency} {balanceDue || '0.00'}</span> {/* Read-only span; defaults to 0.00 if undefined */}
        </div>
      </div>
    </div>
  );
};

export default InvoiceHeader;